module.exports = __webpack_public_path__ + "static/media/git-icon.9858b6a8.png";